<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.add') + $t('attributes.group') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="area_code"
              :label="$t('attributes.area_code')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="region_list_name"
              :label="$t('attributes.region') + $t('attributes.name')"
            >
              <b-input
                v-model="form.region_list_name"
                name="region_list_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              ></b-input>
            </form-group>
            <form-group
              horizontal
              name="status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>
            <form-group
              horizontal
              name="region_list_sort"
              :label="$t('attributes.sort')"
            >
              <b-select v-model="form.region_list_sort" name="region_list_sort">
                <option
                  v-for="option in sort_range"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="region_list_url"
              :label="$t('attributes.url')"
            >
              <b-input
                v-model="form.region_list_url"
                name="region_list_url"
                :placeholder="$t('message.please_input') + $t('attributes.url')"
                expanded
              ></b-input>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 100%"
          >
            {{ $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'AreaRegionCreateForm',
  props: {
    areas: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      sending: false,
      sort_range: [...Array(20).keys()].map(i => i + 1),

      selectedArea: null,
      form: this.initializeFormValues()
    }
  },
  validations: {
    form: {
      area_code: { required },
      region_list_name: { maxLength: maxLength(50), required },
      region_list_no: {},
      region_list_sort: { required },
      region_list_status: {},
      region_list_url: {},
      status: { required }
    }
  },
  watch: {
    region(newRegion) {
      this.form = this.extractFormValues(newRegion)
    }
  },
  methods: {
    initializeFormValues() {
      return {
        area_code: '',
        region_list_name: '',
        region_list_no: '',
        region_list_sort: '',
        region_list_status: 'Y',
        region_list_url: '',
        status: true
      }
    },
    onSelectArea(option) {
      this.selectedArea = option
      this.form.area_code = option.code
    },
    send() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>
